import React, { useCallback, useEffect, useState } from "react";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import ReportDashboardPage from "../../assets/components/reports/ReportDashboardPage";
import Report from "../../models/Report";

function Dashboard({ history, user }) {
    const [filters, setFilters] = useState({});
    const fetchDashboardManifest = useCallback((params, signal) => {
        return Report.dashboardManifest("platform", params, signal);
    }, []);
    const fetchDashboardBatch = useCallback((params, reportBatch, signal) => {
        return Report.dashboardBatch("platform", params, reportBatch, signal);
    }, []);

    useEffect(() => {
        if (user.has("MASHIE_ADMIN") === false) {
            history.push("/members/list");
        }
    }, [history, user]);

    if (user.has("MASHIE_ADMIN") === false) {
        return null;
    }

    return (
        <>
            <div className='d-flex main'>
                <Header history={history} />
                <ReportDashboardPage
                    title='Platform Dashboard'
                    subtitle='Platform-level reporting aligned to MASHIE financial years.'
                    fetchDashboardManifest={fetchDashboardManifest}
                    fetchDashboardBatch={fetchDashboardBatch}
                    filters={filters}
                    onFiltersChange={setFilters}
                />
            </div>
            <Footer />
        </>
    );
}

export default Dashboard;
